import { useState } from "react";
import { useCustomerAnalytics } from "../../../services/hooks/useCustomerAnalytics";
import { useAppDispatch } from "../../../services/hooks/useReduxHooks";
import { useTranslationI18 } from "../../../services/hooks/useTranslationI18";
import { setAcceptedTermsAndConditions } from "../../../services/redux/slices/globalComponentsToggleSlice";
import { setCookie } from "../../../utils/CookieHelper";
import { COOKIE_ENUM, CUSTOMER_ANALYTICS_EVENT } from "../../../utils/enums";
import styles from "./TermsAndConditionsSection.module.scss";

export const TermsAndConditionsSection = () => {
  const { t } = useTranslationI18();
  const dispatch = useAppDispatch();

  const addCustomerAnalytics = useCustomerAnalytics();
  const [shake, setShake] = useState(false);
  const mustAccept = t("terms:must-accept");
  const termsConditions = t("terms:terms-conditions");
  const toProceed = t("terms:to-proceed");
  const handleAccept = () => {
    dispatch(setAcceptedTermsAndConditions(true));
    setCookie(COOKIE_ENUM.TERMSANDCONDITIONS, "true");
    addCustomerAnalytics(CUSTOMER_ANALYTICS_EVENT.ACCEPT_CONSENT);
  };
  const shakeBtn = () => {
    setShake(true);
    setTimeout(() => {
      setShake(false);
    }, 500);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_background} onClick={shakeBtn}></div>
      <div
        className={styles.terms_and_conditions_section}
        data-testid={"terms-condition-drawer"}
      >
        <div className={styles.content_wrapper}>
          <span>
            {`${mustAccept} `}
            <a
              className={styles.link}
              href="https://www.prepitapp.com/privacy-policy"
              target={"_blank"}
              data-testid={"terms-condition-href"}
            >
              {termsConditions}
            </a>
            {` ${toProceed}`}
          </span>
        </div>
        <div className={styles.btn_container}>
          <button
            className={`${styles.btn} ${shake && styles.shake}`}
            onClick={handleAccept}
            data-testid="action-btn"
            style={{ fontSize: "1rem" }}
          >
            {`${t("common:I-accept")}`}
          </button>
        </div>
      </div>
    </div>
  );
};
